import { Component, OnInit, Input, ChangeDetectorRef, forwardRef } from '@angular/core';
import { DatepickerComponent } from '../datepicker/datepicker.component';
import { FieldBaseComponent } from '../field-base/field-base.component';
import * as Moment from 'moment-timezone';
import { Subscription } from '../../../../node_modules/rxjs';
import { L10nTranslationService } from 'angular-l10n';

@Component({
  selector: 'samplicity-timepicker',
  templateUrl: './timepicker.component.html',
  styleUrls: ['./timepicker.component.scss']
})
export class TimepickerComponent<D> extends FieldBaseComponent implements OnInit {

  @Input() linkedDatepicker: DatepickerComponent; // Used if datepicker & timepicker share a formControl
  @Input() time: Date;
  @Input() textMask: string;
  @Input() defaultTime: Moment; // Otherwise defaults to current time if null
  @Input() minTime: Moment;
  @Input() maxTime: Moment;
  @Input() labelTranslated = true;
  @Input() isInvalid = false;

  maskSub: Subscription = new Subscription();

  iePattern = new RegExp(/(?:\b(MS)?IE\s+|\bTrident\/7\.0;.*\s+rv:)(\d+)/);
  controlHasBeenTouched: boolean = false;
  previousControlValue: any = null;

  get isDisabled(): boolean {
    return this.control.disabled;
  }

  constructor(
    cd: ChangeDetectorRef,
    private translationService: L10nTranslationService
  ) {
    super(cd);
  }

  get lang(): string {
    return this.translationService.getLocale().language
  }

  ngOnInit() { }
}
